"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvailableSortOrder = exports.AvailableSortType = exports.GalleryPopState = void 0;
var GalleryPopState;
(function (GalleryPopState) {
    GalleryPopState[GalleryPopState["FULL"] = 0] = "FULL";
    GalleryPopState[GalleryPopState["THUMBS"] = 1] = "THUMBS";
    GalleryPopState[GalleryPopState["MAP"] = 2] = "MAP";
    GalleryPopState[GalleryPopState["NONE"] = 3] = "NONE";
})(GalleryPopState = exports.GalleryPopState || (exports.GalleryPopState = {}));
var AvailableSortType;
(function (AvailableSortType) {
    AvailableSortType[AvailableSortType["QUALITY_SCORE"] = 0] = "QUALITY_SCORE";
    AvailableSortType[AvailableSortType["SALE_PRICE"] = 1] = "SALE_PRICE";
    AvailableSortType[AvailableSortType["SALE_PRICE_PER_SQFT"] = 2] = "SALE_PRICE_PER_SQFT";
    AvailableSortType[AvailableSortType["LEASE_PRICE"] = 3] = "LEASE_PRICE";
    AvailableSortType[AvailableSortType["LEASE_PRICE_PER_SQFT"] = 4] = "LEASE_PRICE_PER_SQFT";
    AvailableSortType[AvailableSortType["NET_SIZE"] = 5] = "NET_SIZE";
    AvailableSortType[AvailableSortType["GROSS_SIZE"] = 6] = "GROSS_SIZE";
    AvailableSortType[AvailableSortType["UPDATE"] = 7] = "UPDATE";
    AvailableSortType[AvailableSortType["BED"] = 8] = "BED";
    AvailableSortType[AvailableSortType["BATH"] = 9] = "BATH";
    AvailableSortType[AvailableSortType["NAME"] = 10] = "NAME";
})(AvailableSortType = exports.AvailableSortType || (exports.AvailableSortType = {}));
var AvailableSortOrder;
(function (AvailableSortOrder) {
    AvailableSortOrder[AvailableSortOrder["ASC"] = 0] = "ASC";
    AvailableSortOrder[AvailableSortOrder["DESC"] = 1] = "DESC";
})(AvailableSortOrder = exports.AvailableSortOrder || (exports.AvailableSortOrder = {}));
